import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { CommonService } from '../../../services/common/common.service';
import { WidgetHelperService } from '../widget-helper.service';
import { WidgetService } from '../../../services/widget/widget.service'
import { UserService } from "../../../services/user/user.service";
declare var webix: any;

@Component({ selector: 'table-chart', templateUrl: './table-chart.component.html', styleUrls: ['./table-chart.component.scss'], encapsulation: ViewEncapsulation.None })
export class TableChartComponent implements OnInit {

  @Input('graphData') graphData: any;
  @Input('isEditable') isEditable: any;
  @Input('groupId') groupId: any;
  @Input('groupData') groupData: any;
  @Input('widget') widget: any;
  @Input('is-schedule') _scheduled: boolean = false;

  hour: string[] = [];
  week: string[] = [];
  month: string[] = [];
  widgetId = "";
  pageInex = 1;
  pivotGrid: any = null;
  thresoldAr = [];
  tableParams: any = 0;
  defaultConfig: any;
  generatedData: any;
  userSession: any;


  constructor(public commonService: CommonService, private widgetHelperService: WidgetHelperService,
    public widgetService: WidgetService, public userService: UserService) {
      this.userSession = this.userService.getLoggedInUser();
  }

  ngOnInit() {
    this.widgetId = this.graphData.udf.widgetId;
    this.commonService.getAction().subscribe(data => {
      if (["showDesignerPivot"].includes(data.action)) {
        if (["updateWidget"].includes(data.data.action)) {
          if (this.defaultConfig) {
            this.widgetService.widgetUpdate({ 'widgetId': this.widgetId, 'isSwitchReport': 0, 'structure': {} }).subscribe();
            this.widget.structure = {};
            this.widget.isSwitchReport = 0;
          }
        }
        this.pivotGrid.config.readonly = !data.data.showPv;
        this.pivotGrid.config.drag = !data.data.showPv;
        this.pivotGrid.refresh();
      }
      if (["showResizeTablePivot"].includes(data.action)) {
        this.processTD();
      }
      if (["resetTableConfig"].includes(data.action) && data.data.widgetId == this.widgetId) {
        this.resetConfig();
      }
    })
  }

  ngAfterViewInit() {
    if (this.widget.isSwitchReport === 1 && this.groupData.consolidateSiteData === 1) {
      this.widgetService.widgetUpdate({ 'widgetId': this.widgetId, 'isSwitchReport': 0, "supress": 1 }).subscribe();
      this.widget.isSwitchReport = 0;
    }
    setTimeout(() => {
      this.processTD();
    }, 10);
  }

  processTD() {
    if (webix.$$("pivotTable" + this.widgetId)) {
      webix.$$("pivotTable" + this.widgetId).destructor();
    }
    let that = this;
    this.widgetId = this.graphData.udf.widgetId;
    let columns = ["Site"];
    let values = [];
    let rows = ['date'];
    let _thresold = [];
    this.thresoldAr = this.graphData.udf.numericConfig.thresholdSettings ? this.graphData.udf.numericConfig.thresholdSettings : [];
    this.thresoldAr.forEach(_th => {
      if (_th.showThresold)
        _thresold[_th.label] = _th;
    });
    if (this.graphData.dataFilter && this.graphData.dataFilter.constructor == Array && this.graphData.dataFilter.length > 0) {
      let isConsolidateData = this.groupData && this.groupData.consolidateData ? this.groupData.consolidateData : 0;
      let res = this.generatedData, adjustHeaderLabel = false;
      
      if (!res)
        this.generatedData = res = this.widgetHelperService.getDataTable(this.graphData, 0, isConsolidateData);
      if (res) {     
        if (this.graphData.udf.hasOwnProperty('isAdjustHeader'))
          adjustHeaderLabel = this.graphData.udf.isAdjustHeader;
        if (res.Data.length > 0 && !res.Data[0]["date"]) {
          res.Data.forEach(_d => {
            _d["date"] = "No Data";
          });
          res.totals.column = res.totals.row = false;
        }
        if (res.hasZone) {
          columns.push("Zone");
          res.Site = Array.from(new Set(res.Site));
        }
        if (res.Site.length === 0) {
          if (that.widget.isSwitchReport == 1) {
            columns = rows;
            rows = [];
          } else {
            columns = [];
          }
        }
        res.ValueFilter.forEach((v) => {
          values.push({ name: v, operation: ["sum"] });
        });
        if (res.Site.length > 0)
          this.tableParams = res.ValueFilter.length * res.Site.length;
        else
          this.tableParams = res.ValueFilter.length;
        $(function () {
          that.defaultConfig = {
            rows: rows,
            columns: columns,
            values: values
          };
          let structure: any = that.widget.structure && Object.keys(that.widget.structure).length > 0 ? JSON.parse(that.widget.structure) : that.defaultConfig;
          // structure.values = that.defaultConfig.values;
          if (!webix.env.touch && webix.env.scrollSize)
            webix.CustomScroll.init();
          that.pivotGrid = webix.ui({
            container: ("compareTable" + that.widgetId),
            id: ("pivotTable" + that.widgetId),
            view: "pivot",
            data: res.Data,
            readonly: !that.isEditable,
            readonlyTitle: that.getGroupByName(that.graphData.timeFrame),
            footer: res.totals.column,
            totalColumn: res.totals.row,
            freezeTotal: false,
            seperateLabel: false,
            structure: structure,
            datatable: {
              autoheight: true,
              autowidth: true
            },
            on: {
              onBeforeApply: function (structure) {
                if (structure.columns[0] == "date" && structure.rows[0] == "Site") {
                  that.widgetService.widgetUpdate({ 'widgetId': that.widgetId, 'isSwitchReport': 1, 'structure': JSON.stringify(structure) }).subscribe();
                  that.widget.structure = JSON.stringify(structure);
                  that.widget.isSwitchReport = 1;
                } else if (structure.columns[0] == "Site" && structure.rows[0] == "date") {
                  that.widgetService.widgetUpdate({ 'widgetId': that.widgetId, 'isSwitchReport': 0, 'structure': JSON.stringify(structure) }).subscribe();
                  that.widget.structure = JSON.stringify(structure);
                  that.widget.isSwitchReport = 0;
                }
                else {
                  that.widgetService.widgetUpdate({ 'widgetId': that.widgetId, 'isSwitchReport': 0, 'structure': JSON.stringify(structure) }).subscribe();
                  that.widget.structure = JSON.stringify(structure);
                  that.widget.isSwitchReport = 0;
                }
                that.processTD();

              },
              onBeforeRender: function (config) {
                var columns = config.header;
                columns.forEach((_column,index) => {
                  if (adjustHeaderLabel && Array.isArray(_column.header)) {
                    let _cwidth = Number(Math.max.apply(Math, _column.header.filter(x => x && x.text).map(x => x.text).map(el => el.length))) * 14 * 0.8;
                    if (_column.width < _cwidth)
                      _column.width = _cwidth;
                  }
                  else {
                    if(index > 0 && that.userSession.ownerId == "67d7f92c7ede084278893af2")
                      _column.width = 95;
                  }

                  _column.cssFormat = function (value, item, itemId, columnId) {
                    if (columnId === 'name')
                      return;
                    let oName = columnId.replace(/'/g, '').replace('sum', '').replace('count', '').replace('max', '').replace('min', '').split('_'), kName = oName[oName.length - 1];
                    oName = oName.slice(0, -1).filter(x => x).join('::');
                    let style: any = { "text-align": "right" };
                    if (_thresold[kName]) {
                      if (_thresold[kName]["islessThan"] && value <= _thresold[kName]['lessThan'])
                        style["background-color"] = _thresold[kName]['lessThanColor'];
                      else if (_thresold[kName]["isBetween"] && value >= _thresold[kName]['betweenFrom'] && value <= _thresold[kName]['betweenTo'])
                        style["background-color"] = _thresold[kName]['betweenColor'];
                      else if (_thresold[kName]["isGreaterThan"] && value >= _thresold[kName]['greaterThan'])
                        style["background-color"] = _thresold[kName]['greaterThanColor'];
                    }
                    else
                      style["background-color"] = res.Color[oName];
                    return style;
                  };

                  if (!_column["exportAsTree"]) {
                    _column.template = function (obj, common, value, columnId) {
                      if (columnId.id === 'name' || !value)
                        return value;
                      let oName = columnId.id.split('_'), kName = oName[oName.length - 1];
                      oName = oName[0] + '::' + kName;                      
                      value = (res.formatNumber[kName] == "-1" ? that.commonService.shortNumberFormat(value) : parseFloat(value).toFixed(res.formatNumber[kName]));                      
                      if (res.isThousandSeperator[kName])
                        value = that.commonService.formatNumberString(value, true);
                      else
                        value = that.commonService.formatNumberString(value, false);
                      return value;
                    };
                  }
                  if (res.totals.column && _column.footer.text) {
                    let oName = _column.id.split('_'), kName = oName[oName.length - 1];
                    oName = oName[0] + '::' + kName;
                    if (res.calculatedKpis[kName])
                      _column.footer.text = res.calculatedKpis[kName];
                    _column.footer.text = (res.formatNumber[kName] == "-1" ? that.commonService.shortNumberFormat(_column.footer.text) : parseFloat(_column.footer.text).toFixed(res.formatNumber[kName]));
                    if (res.isThousandSeperator[kName])
                      _column.footer.text = that.commonService.formatNumberString(_column.footer.text, true);
                    else
                      _column.footer.text = that.commonService.formatNumberString(_column.footer.text, false);
                    return _column.footer.text;
                  }
                });
              },
              onPopup: function (popup) {
                popup.$$("fields").attachEvent("onAfterLoad", function () {
                  this.filter(function (item) {
                    if (["Site", "Zone", "date"].includes(item.text))
                      return item;
                  });
                });
              },
              onRenderDone: webix.once(function () {
                that.setIntialDimensions(this.$height, this.$width);
              })
            }
          });
        });
      }
    }
  }

  setIntialDimensions(h: any, w: any) {
    h = h + 2;
    var containerWidth = $('#compareTable' + this.widgetId).width();
    var assumedHeight = h, assumedWidth = w;
    if (!this._scheduled) {
      if (assumedHeight > 800)
        assumedHeight = 800;
      if (!webix.env.touch && assumedWidth > containerWidth) {
        assumedWidth = containerWidth;
      }
    }
    this.pivotGrid.config.width = assumedWidth;
    this.pivotGrid.config.height = assumedHeight;
    if (h > 800 && !this._scheduled) {
      this.pivotGrid.$$('data').config.autoheight = false;
      this.pivotGrid.$$('data').config.height = 795;
    }
    else {
      this.pivotGrid.$$('data').config.autoheight = true;
    }
    this.pivotGrid.resize();
    this.pivotGrid.refresh();
    this.pivotGrid.$$('data').refresh();
  }

  getGroupByName(name) {
    switch (name) {
      case "hour":
        return "Hour";
      case "dayOfMonth":
        return "Date";
      case "dayOfWeek":
        return "Week Day";
      case "week":
        return "Week";
      case "month":
        return "Month";
      case "year":
        return "Year";
      default:
        return "Date";
    }
  }

  resetConfig() {
    if (this.defaultConfig) {
      this.widgetService.widgetUpdate({ 'widgetId': this.widgetId, 'isSwitchReport': 0, 'structure': {} }).subscribe();
      this.widget.structure = {};
      this.widget.isSwitchReport = 0;
      this.processTD();
    }
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/table-chart/table-chart.component.ts